module.exports = __webpack_public_path__ + "img/addition.2c64d99b.svg";